import React, { useEffect, useState } from "react";
import {
  AreaChart,
  Area,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { useDashboardService } from "../../services/dashboardService";
import { Paper, Typography, Box } from "@mui/material";
import dayjs from "dayjs";

const CheckInStatsChart = ({ selectedDate, selectedVertical = "All" }) => {
  const { fetchCheckInStats } = useDashboardService();
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    const loadData = async () => {
      const rawData = (await fetchCheckInStats({ asOnDate: selectedDate })) || [];

      // Group data by date
      const grouped = {};
      rawData.forEach((entry) => {
        const date = dayjs(entry.CheckInDate).format("MMM-DD");
        if (!grouped[date]) grouped[date] = [];

        if (
          selectedVertical === "All" ||
          entry.Business_Vertical_Desc === selectedVertical
        ) {
          grouped[date].push(entry);
        }
      });

      // Build chart data
      const finalData = Object.entries(grouped).map(([date, entries]) => {
        let totalCheckIns = 0;
        let totalEmployees = 0;

        entries.forEach((entry) => {
          totalCheckIns += entry.TotalCheckIns;
          totalEmployees += entry.TotalEmployee;
        });

        const checkInPercentage =
          totalEmployees > 0
            ? parseFloat(((totalCheckIns / totalEmployees) * 100).toFixed(2))
            : 0;

        return { date, checkInPercentage };
      });

      setChartData(finalData);
    };

    loadData();
  }, [selectedDate, selectedVertical]);

  return (
    <Box elevation={2}  
     sx={{ 
        borderRadius: 2,
        p: 1, height: "100%",
        boxShadow: 1,
        bgcolor: "background.paper", 
        alignItems: "center", 
      }} 
    >
      <Typography variant="h6" gutterBottom>
        Daily Check-In %
      </Typography>
      <Box sx={{ height: 205 }}>
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart
            data={chartData}
            margin={{ top: 10, right: 10, bottom: 5, left: 0 }}
          >
            <defs>
              <linearGradient id="colorCheckIn" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#1976d2" stopOpacity={0.8} />
                <stop offset="95%" stopColor="#1976d2" stopOpacity={0.05} />
              </linearGradient>
            </defs>
            <XAxis
              dataKey="date"
              angle={-45}
              textAnchor="end"
              interval={0}
              height={60}
            />
            <YAxis unit="%" domain={[0, 100]} />
            <Tooltip
              formatter={(value) => [`${value}%`, "Check-In %"]}
            />
            <Area
              type="monotone"
              dataKey="checkInPercentage"
              stroke="#1976d2"
              fillOpacity={1}
              fill="url(#colorCheckIn)"
            />
            <CartesianGrid strokeDasharray="3 3" />
          </AreaChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};

export default CheckInStatsChart;
